const invoiceEditorLocale = 'payment_schedules.invoice_editor'
const invoiceListLocale = 'payment_schedules.invoice_list'
export default {
  invoiceEditor: {
    label: `${invoiceEditorLocale}.label`,
    menu: `${invoiceEditorLocale}.menu`,
    type: {
      label: `${invoiceEditorLocale}.type.label`,
      sameInvoice: `${invoiceEditorLocale}.type.sameInvoice`,
      advanceInvoice: `${invoiceEditorLocale}.type.advanceInvoice`,
      customInvoice: `${invoiceEditorLocale}.type.customInvoice`,
      sameInvoiceShort: `${invoiceEditorLocale}.type.sameInvoice_short`,
      advanceInvoiceShort: `${invoiceEditorLocale}.type.advanceInvoice_short`,
      deposit: `${invoiceEditorLocale}.type.deposit`,
      schedule: `${invoiceEditorLocale}.type.schedule`,
    },
    noOfPayments: {
      label: `${invoiceEditorLocale}.noOfPayments.label`,
      max: `${invoiceEditorLocale}.noOfPayments.max`,
    },
    period: {
      label: `${invoiceEditorLocale}.period.label`,
      monthly: `${invoiceEditorLocale}.period.monthly`,
      weekly: `${invoiceEditorLocale}.period.weekly`,
      biWeekly: `${invoiceEditorLocale}.period.biWeekly`,
      quarterly: `${invoiceEditorLocale}.period.quarterly`,
      semiAnnually: `${invoiceEditorLocale}.period.semiAnnually`,
      annually: `${invoiceEditorLocale}.period.annually`,
    },
    noOfInvoices: {
      label: `${invoiceEditorLocale}.noOfInvoices.label`,
      onePerPayment: `${invoiceEditorLocale}.noOfInvoices.1PerPayment`,
      oneInTotal: `${invoiceEditorLocale}.noOfInvoices.1InTotal`,
    },
    name: {
      label: `${invoiceEditorLocale}.name.label`,
    },
  },
  invoiceList: {
    number: {
      advance: `${invoiceListLocale}.number.advance`,
      final: `${invoiceListLocale}.number.final`,
    },
  },
}
